import { render, staticRenderFns } from "./GuideInfoSection.vue?vue&type=template&id=2948df45&scoped=true"
import script from "./GuideInfoSection.vue?vue&type=script&lang=js"
export * from "./GuideInfoSection.vue?vue&type=script&lang=js"
import style0 from "./GuideInfoSection.vue?vue&type=style&index=0&id=2948df45&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2948df45",
  null
  
)

export default component.exports